/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PracticeProfileDto } from './PracticeProfileDto';
import {
    PracticeProfileDtoFromJSON,
    PracticeProfileDtoFromJSONTyped,
    PracticeProfileDtoToJSON,
    PracticeProfileDtoToJSONTyped,
} from './PracticeProfileDto';

/**
 * 
 * @export
 * @interface AppleSignInRequest
 */
export interface AppleSignInRequest {
    /**
     * Firebase ID token obtained after signing in with the Apple credential on the client
     * @type {string}
     * @memberof AppleSignInRequest
     */
    idToken: string;
    /**
     * Type of user account
     * @type {string}
     * @memberof AppleSignInRequest
     */
    userType: AppleSignInRequestUserTypeEnum;
    /**
     * Platform (web/mobile)
     * @type {string}
     * @memberof AppleSignInRequest
     */
    platform?: string;
    /**
     * Is sign up
     * @type {boolean}
     * @memberof AppleSignInRequest
     */
    isSignUp?: boolean;
    /**
     * Practice details (provider sign-up only)
     * @type {PracticeProfileDto}
     * @memberof AppleSignInRequest
     */
    practiceProfile?: PracticeProfileDto;
}


/**
 * @export
 */
export const AppleSignInRequestUserTypeEnum = {
    Patient: 'patient',
    Provider: 'provider',
    Admin: 'admin'
} as const;
export type AppleSignInRequestUserTypeEnum = typeof AppleSignInRequestUserTypeEnum[keyof typeof AppleSignInRequestUserTypeEnum];


/**
 * Check if a given object implements the AppleSignInRequest interface.
 */
export function instanceOfAppleSignInRequest(value: object): value is AppleSignInRequest {
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('userType' in value) || value['userType'] === undefined) return false;
    return true;
}

export function AppleSignInRequestFromJSON(json: any): AppleSignInRequest {
    return AppleSignInRequestFromJSONTyped(json, false);
}

export function AppleSignInRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppleSignInRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idToken': json['idToken'],
        'userType': json['userType'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'isSignUp': json['isSignUp'] == null ? undefined : json['isSignUp'],
        'practiceProfile': json['practiceProfile'] == null ? undefined : PracticeProfileDtoFromJSON(json['practiceProfile']),
    };
}

export function AppleSignInRequestToJSON(json: any): AppleSignInRequest {
    return AppleSignInRequestToJSONTyped(json, false);
}

export function AppleSignInRequestToJSONTyped(value?: AppleSignInRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idToken': value['idToken'],
        'userType': value['userType'],
        'platform': value['platform'],
        'isSignUp': value['isSignUp'],
        'practiceProfile': PracticeProfileDtoToJSON(value['practiceProfile']),
    };
}

